/**
 * The ghost hint shown in an empty text block, and the rule deciding which
 * blocks get one.
 *
 * The hint is editor-only chrome: it is drawn by the renderer
 * (EmptyTextPlaceholder) and by the TipTap Placeholder extension during an
 * edit session, and it never enters the stored document HTML - so it cannot
 * reach the customer-facing quote page or the PDF.
 */

/** The ghost hint drawn in an empty text block, advertising the "]" menu. */
export const EMPTY_TEXT_HINT = "Type ] for quote field";

/** Prose tags whose empty state is worth a hint (lists and cells excluded). */
const HINTED_TAGS = new Set([
  "p",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "blockquote",
  "figcaption",
]);

/**
 * Whether an element is an empty prose block: one that would render as a
 * zero-height, unclickable sliver on the canvas without a hint standing in
 * for its missing content.
 * @param element - The source element about to be converted for rendering
 * @returns True when the element is a hint-worthy empty prose block
 */
export function isEmptyProseBlock(element: Element): boolean {
  return (
    HINTED_TAGS.has(element.tagName.toLowerCase()) &&
    element.children.length === 0 &&
    (element.textContent ?? "").trim() === ""
  );
}
